import { useNavigate, useParams } from 'react-router-dom';
import './oildetail.css';

const oilData = {
  coconut: {
    name: 'Coconut Oil',
    image: '/images/oil/coconut.webp',
    description:
      'Coconut Oil in Tamil Nadu is traditionally extracted using the cold-pressed (chekku) method from sun-dried coconuts grown in the southern coastal regions like Pollachi, Kanyakumari, and Thanjavur. This method preserves its natural aroma, nutrients, and medicinal properties.Tamil households trust coconut oil for its cooling nature, believed to support digestion, skin health, and brain function. It is widely used in cooking, hair care, and even in Ayurvedic treatments. Considered a satvik ingredient, it’s often used in temple cooking and festive meals. Elders regard it as a natural immunity booster and a digestive aid when consumed regularly in moderation.',
  },
  sesame: {
    name: 'Sesame Oil',
    image: '/images/oil/sesame.webp',
    description:
      'Sesame Oil, known locally as Nalla Ennai (நல்ல எண்ணெய்), is a staple in Tamil Nadu kitchens. It is traditionally cold-pressed (chekku oil) from premium black sesame seeds grown in regions like Erode, Vellore, and Tirunelveli. This slow extraction method retains its rich aroma, deep color, and medicinal properties.Tamil people believe sesame oil enhances body strength, balances body heat, and improves digestion. It is widely used in cooking, oil baths (ennai kuliyal), and Siddha medicine. Regarded as a sacred oil, it’s also used in lamp lighting and rituals, symbolizing purity and longevity. Known for its anti-inflammatory and detoxifying effects, it’s especially valued for joint health and skin nourishment.',
  },
  groundnut: {
    name: 'Groundnut Oil',
    image: '/images/oil/groundnut.webp',
    description:
      'Groundnut Oil, also known as Kadalai Ennai (கடலை எண்ணெய்) in Tamil, is commonly extracted using the cold-pressed (chekku) method from sun-dried groundnuts grown in regions like Virudhunagar, Madurai, and Theni. This traditional method helps retain its natural flavor, nutrients, and aromatic richness.In Tamil culture, groundnut oil is considered heart-healthy, believed to support joint flexibility, enhance energy, and reduce bad cholesterol. It is widely used for deep frying, sautéing, and in dishes like kootu, poriyal, and murukku. Many Tamil families prefer it over refined oils, trusting its digestive friendliness and long-lasting freshness.',
  },
  deepam: {
    name: 'dheepam Oil',
    image: '/images/oil/dheepam.webp',
    description:
      'Deepam Oil, traditionally used for lighting vilakku (lamps) in Tamil Nadu, is usually a blend of oils like sesame, castor, neem, and mahua. It is prepared with care, often using pure, unrefined oils sourced from regions like Kumbakonam, Thiruvannamalai, and Madurai, known for spiritual and temple practices.In Tamil culture, lighting a lamp with deepam oil is believed to remove negativity, bring prosperity, and purify the home environment. Each oil in the blend carries symbolic and spiritual significance—for instance, sesame oil is said to calm the mind, while castor oil is thought to ward off evil. Deepam oil is especially used during auspicious days, poojas, and festivals like Karthigai Deepam, upholding centuries-old traditions.',
  },
  olive: {
    name: 'Olive Oil',
    image: '/images/oil/olive.webp',
    description:
      'Olive Oil, though not native to Tamil Nadu, is increasingly embraced in urban kitchens across Chennai, Coimbatore, and Tiruchirapalli for its health benefits and light flavor. Mostly imported from Mediterranean countries, its used in salads, continental dishes, and light sautéing.Health-conscious Tamil families believe olive oil helps reduce cholesterol, protect heart health, and support weight management. It is often chosen for its antioxidants and healthy fats, especially by those managing diabetes or lifestyle disorders. While not used in traditional recipes, it’s gaining popularity for modern diets, especially among the younger generation and fitness enthusiasts.',
  },
  sunflower: {
    name: 'Sunflower Oil',
    image: '/images/oil/sunflower.webp',
    description:
      'Sunflower Oil is widely used in modern Tamil Nadu households, especially in cities like Chennai, Salem, and Tirunelveli, for its neutral taste and light texture. Extracted from sunflower seeds, it is commonly refined and used for deep frying, everyday cooking, and even in school meal programs.Tamil people prefer sunflower oil for being cholesterol-free, easy on digestion, and rich in Vitamin E, which is believed to support skin health, boost immunity, and improve heart function. While not a traditional oil, it is now a popular choice among health-conscious families seeking a light, versatile alternative to heavier oils.',
  },
  mustard: {
    name: 'Mustard Oil',
    image: '/images/oil/mustard.webp',
    description:
      'Mustard Oil, though more common in northern and eastern India, is also used in certain Tamil households, especially for medicinal and therapeutic purposes. It is extracted from mustard seeds and known for its sharp aroma, strong flavor, and warming nature.In Tamil Nadu, mustard oil is used more in traditional remedies than daily cooking. It is believed to stimulate digestion, improve blood circulation, and relieve muscle pain when used for body massage. Siddha practitioners sometimes recommend it for joint pain and cold relief. While less common in Tamil cooking, it is gaining niche interest for its antibacterial and heart-friendly properties.',
  }
};

const OilDetail = () => {
  const { type } = useParams();
  const oil = oilData[type];
  const navigate = useNavigate();
  const goToProducts = () => {
        navigate('/oil');
    };

  if (!oil) return <h2>Oil not found</h2>;

  return (
    <section
      className="sesame-section"
      style={{ backgroundImage: `url(${oil.image})` }}
    >
      <div className="sesame-content">
        <div className="text-content">
          <button className='back-btn-viewmore' onClick={goToProducts}>⟵ Back to Oil Products</button>
          <h2>{oil.name}</h2>
          <p>{oil.description}</p>
        </div>
        <div className="button-box">
          <button className="enquire-btn">ENQUIRE NOW</button>
      </div>
      </div>
      
    </section>
  );
};

export default OilDetail;
